import {v4 as uuidv4} from "uuid";
import {faker}  from "@faker-js/faker";
import { getAccounts } from "../helpers/get-accounts";
//import defaultValues from "../scenarios/default";
import defaultValuesOld from "../scenarios/edu-scenarios";

var regionCodes = [
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2",
  "ap-south-1",
];

var os = defaultValuesOld().os;

let owners = ["MontyCloud", "AWS"];
const mcPatchPolicies = defaultValuesOld().patchPolicies;

export const allPatchPolicies = async () => {
  let patchPolicies = [];
  let accounts = await getAccounts();

  mcPatchPolicies.forEach((policy) => {
    var patchPolicy = {
      AccountNumber: faker.helpers.arrayElement(accounts),
      BaselineDescription: policy.Description,
      BaselineId: "",
      BaselineName: policy.policyName,
      DefaultBaseline: faker.random.boolean(),
      OperatingSystem: policy.operatingSystem,
      RegionCode: faker.helpers.arrayElement(regionCodes),
      Owner: faker.helpers.arrayElement(owners),
    };

    patchPolicy.BaselineId = `arn:aws:ssm:${patchPolicy.RegionCode}:${
      patchPolicy.AccountNumber
    }:patchbaseline/pb-${faker.random.alphaNumeric(10)}`;
    patchPolicy.Matches = [
      {
        RegionCode: patchPolicy.RegionCode,
        BaselineId: patchPolicy.BaselineId,
        AccountNumber: patchPolicy.AccountNumber,
      },
    ];
    patchPolicies.push(patchPolicy);
  });

  os.forEach((item) => {
    var patchPolicy = {
      AccountNumber: faker.helpers.arrayElement(accounts),
      BaselineDescription: "",
      BaselineId: "",
      BaselineName: "",
      DefaultBaseline: faker.random.boolean(),
      OperatingSystem: item,
      RegionCode: faker.helpers.arrayElement(regionCodes),
      Owner: faker.helpers.arrayElement(owners),
    };
    patchPolicy.BaselineDescription = `Default Patch Baseline for ${patchPolicy.OperatingSystem} Provided by AWS.`;
    patchPolicy.BaselineId = `arn:aws:ssm:${patchPolicy.RegionCode}:${
      patchPolicy.AccountNumber
    }:patchbaseline/pb-${faker.random.alphaNumeric(10)}`;
    patchPolicy.BaselineName = `AWS-${patchPolicy.OperatingSystem.trim()}DefaultPatchBaseline`;
    patchPolicy.Matches = [
      {
        RegionCode: patchPolicy.RegionCode,
        BaselineId: patchPolicy.BaselineId,
        AccountNumber: patchPolicy.AccountNumber,
      },
    ];
    patchPolicies.push(patchPolicy);
  });

  return patchPolicies;
};
export const patchPolicyData = (patchPolicy) => {
  const data = {
    ApprovedPatchesEnableNonSecurity: false,
    BaselineId: patchPolicy.BaselineId,
    Name: patchPolicy.BaselineName,
    ResponseMetadata: {
      RetryAttempts: 0,
      HTTPStatusCode: 200,
      RequestId: "d4fcc672-fb87-400f-ad03-e403e139e3d1",
      HTTPHeaders: {
        "x-amzn-requestid": "d4fcc672-fb87-400f-ad03-e403e139e3d1",
        date: "Thu,16 May 2019 06:17:48 GMT",
        "content-length": "789",
        "content-type": "application/x-amz-json-1.1",
      },
    },
    PatchGroups: [
      "Dev",
      "Server Group",
      "abc",
      "Prod-Instances",
      "Hello15",
      "Demo-PatchGroup",
      "Tatata",
    ],
    RejectedPatches: [],
    GlobalFilters: {
      PatchFilters: [],
    },
    Sources: [],
    ApprovalRules: {
      PatchRules: [
        {
          PatchFilterGroup: {
            PatchFilters: [
              {
                Values: ["*"],
                Key: "PRODUCT",
              },
            ],
          },
          ApproveAfterDays: 7,
          ComplianceLevel: "UNSPECIFIED",
          EnableNonSecurity: true,
        },
      ],
    },
    ModifiedDate: "2018-03-29T17:38:12.515000+00:00",
    CreatedDate: "2018-03-29T17:38:12.515000+00:00",
    ApprovedPatchesComplianceLevel: "UNSPECIFIED",
    OperatingSystem: patchPolicy.OperatingSystem,
    ApprovedPatches: [],
    Description: patchPolicy.BaselineDescription,
  };
  return data;
};

export const savePolicyData = async (patchPolicyData) => {
  const accounts = await getAccounts();
  let account = faker.helpers.arrayElement(accounts);
  let region = faker.helpers.arrayElement(regionCodes);
  let newPolicy = {
    AccountNumber: account,
    BaselineDescription: patchPolicyData.PolicyInfo.Description,
    BaselineId: `arn:aws:ssm:${region}:${account}:patchbaseline/pb-${faker.random.alphaNumeric(
      10
    )}`,
    BaselineName: patchPolicyData.PolicyInfo.Name,
    DefaultBaseline: false,
    OperatingSystem: patchPolicyData.PolicyInfo.OperatingSystem,
    RegionCode: region,
    Owner: "MontyCloud",
    Matches: [
      {
        RegionCode: region,
        BaselineId: `arn:aws:ssm:${region}:${account}:patchbaseline/pb-${faker.random.alphaNumeric(
          10
        )}`,
        AccountNumber: account,
      },
    ],
  };

  return newPolicy;
};

export const patchStates = () => {
  const patches = [];
  for (let i = 0; i <= 10; i++) {
    const item = {
      ID: uuidv4(),
      Name: `KB4539${faker.number.int({ min: 100, max: 999 })}`,
      State: faker.helpers.arrayElement([
        "Installed",
        "InstalledOther",
        "Missing",
      ]),
      Classification: "Security",
      Severity: faker.helpers.arrayElement(["Critical", "Important"]),
      ComplianceLevel: "UNSPECIFIED",
      InstalledTime: "2022-01-11 04:32:33+00:00",
    };
    patches.push(item);
  }
  return patches;
};
